import { createActionGroup, props } from '@ngrx/store';
import { AvailableLookupOsUpdate } from './available-lookup-os-update.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AvailableLookupOsUpdateResolverActions = createActionGroup({
  source: 'Available Lookup OS Update Resolver',
  events: {
    'Available Lookup OS Updates requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AvailableLookupOsUpdateApiActions = createActionGroup({
  source: 'Available Lookup OS Update API',
  events: {
    'Available Lookup OS Updates loaded': props<{ availableLookupOsUpdates: AvailableLookupOsUpdate[] }>(),
    'Available Lookup OS Updates loaded error': props<{ error: ErrorModel }>(),
  },
});
